<div class="modal flex flex-col">
  <div class="flex flex-1 justify-center">
    <img [src]="data.imageUrl" />
  </div>
</div>
